import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, ArrowRightIcon, StarIcon } from 'lucide-react';
const comparisonData = [{
  feature: 'Built-in database of 200M+ local businesses',
  openmart: true,
  generic: false
}, {
  feature: 'Verified owner emails included at no extra cost',
  openmart: true,
  generic: false
}, {
  feature: 'Automated multi-touch email sequences',
  openmart: true,
  generic: true
}, {
  feature: 'Dynamic personalization tags (tech stack, revenue)',
  openmart: true,
  generic: false
}, {
  feature: 'Native CRM sync (HubSpot, Salesforce)',
  openmart: true,
  generic: true
}, {
  feature: 'Designed specifically for local business prospecting',
  openmart: true,
  generic: false
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};
const rowVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24
    }
  }
};
export function SequenceComparison() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-749">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-50/50 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-750" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-751">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-752">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-753">
            Why sales teams choose{' '}
            <span className="text-blue-600" data-id="element-754">Openmart</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-755">
            Compare our platform against other email sequence software and
            tools.
          </p>
        </div>

        <div className="relative" data-id="element-756">
          <div className="grid grid-cols-[2fr_1fr_1fr] md:grid-cols-[3fr_1.5fr_1.5fr] items-end mb-4 px-4 md:px-8" data-id="element-757">
            <div className="pb-6" data-id="element-758">
              <h3 className="text-xl font-bold text-slate-900" data-id="element-759">
                Feature comparison
              </h3>
            </div>
            <div className="pb-6 text-center relative z-10" data-id="element-760">
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-761">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-762" /> Recommended
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-763">Openmart</h3>
            </div>
            <div className="pb-6 text-center" data-id="element-764">
              <h3 className="text-lg font-semibold text-slate-500" data-id="element-765">
                Other Sequence Tools
              </h3>
            </div>
          </div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} className="relative" data-id="element-766">
            <div className="absolute top-0 bottom-0 bg-slate-50/80 rounded-[2rem] border border-slate-100 shadow-sm -z-10" style={{
            left: 'calc(50% + 0px)',
            width: '25%'
          }} data-id="element-767" />
            <div className="flex flex-col" data-id="element-768">
              {comparisonData.map((row, index) => {
              const isFirst = index === 0;
              const isLast = index === comparisonData.length - 1;
              return <motion.div key={index} variants={rowVariants} className="grid grid-cols-[2fr_1fr_1fr] md:grid-cols-[3fr_1.5fr_1.5fr] items-center group transition-colors hover:bg-slate-50/50 rounded-2xl" data-id="element-769">
                    <div className="py-5 px-4 md:px-8 border-b border-slate-100 group-last:border-0" data-id="element-770">
                      <span className="text-lg font-medium text-slate-700" data-id="element-771">
                        {row.feature}
                      </span>
                    </div>
                    <div className={`py-5 px-2 flex justify-center items-center bg-slate-50/80 border-x border-slate-100/50 relative z-10 ${isFirst ? 'rounded-t-[2rem] border-t' : ''} ${isLast ? 'rounded-b-[2rem] border-b shadow-sm' : ''} ${!isLast ? 'border-b border-slate-100/50' : ''}`} data-id="element-772">
                      {row.openmart ? <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center" data-id="element-773">
                          <CheckIcon className="w-5 h-5 text-blue-600" strokeWidth={3} data-id="element-774" />
                        </div> : <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center" data-id="element-775">
                          <XIcon className="w-5 h-5 text-slate-300" strokeWidth={2} data-id="element-776" />
                        </div>}
                    </div>
                    <div className="py-5 px-2 flex justify-center items-center border-b border-slate-100 group-last:border-0" data-id="element-777">
                      {row.generic ? <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center" data-id="element-778">
                          <CheckIcon className="w-5 h-5 text-slate-400" strokeWidth={2} data-id="element-779" />
                        </div> : <div className="w-8 h-8 rounded-full flex items-center justify-center" data-id="element-780">
                          <XIcon className="w-5 h-5 text-slate-200" strokeWidth={2} data-id="element-781" />
                        </div>}
                    </div>
                  </motion.div>;
            })}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.8,
          duration: 0.5
        }} className="mt-12 text-center" data-id="element-782">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-783">
              <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-10 py-4 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition-colors text-lg" data-id="element-784">
                Try for free <ArrowRightIcon className="w-5 h-5" data-id="element-785" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}